module.exports = __webpack_public_path__ + "static/media/biDefi.59df5799.jpg";